import React from "react";
import { Helmet } from "react-helmet";

const RajasthanSEO = () => {
  return (
    <Helmet>
      {/* 🟢 BASIC META */}
      <title>
        Buy Sex Toys in Rajasthan | Discreet Delivery in Jaipur, Jodhpur
      </title>

      <meta
        name="description"
        content="Buy sex toys online in Rajasthan with 100% discreet delivery. Trusted adult store delivering to Jaipur, Jodhpur, Udaipur, Kota & Ajmer. Products for men, women & couples."
      />

      <meta
        name="keywords"
        content="sex toys in Rajasthan, buy sex toys Jaipur, sex toys Jodhpur, adult toys Rajasthan, couples sex toys Rajasthan, adult store Rajasthan"
      />

      <meta name="robots" content="index, follow" />

      {/* 🟢 CANONICAL */}
      <link
        rel="canonical"
        href="https://lushdesire.in/sex-toys-delivery/rajasthan"
      />

      {/* 🟢 OPEN GRAPH */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Buy Sex Toys in Rajasthan | 100% Discreet Delivery"
      />
      <meta
        property="og:description"
        content="Order premium sex toys in Rajasthan with fast & private delivery. Serving Jaipur, Jodhpur, Udaipur & more."
      />
      <meta
        property="og:url"
        content="https://lushdesire.in/sex-toys-delivery/rajasthan"
      />
      <meta
        property="og:image"
        content="https://lushdesire.in/assets/og-rajasthan.jpg"
      />

      {/* 🟢 TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Sex Toys Delivery in Rajasthan | LushDesire"
      />
      <meta
        name="twitter:description"
        content="Discreet sex toys delivery across Rajasthan. Buy toys for men, women & couples online."
      />

      {/* 🟢 LOCAL SEO */}
      <meta name="geo.region" content="IN-RJ" />
      <meta name="geo.placename" content="Rajasthan" />
      <meta name="geo.position" content="27.0238;74.2179" />
      <meta name="ICBM" content="27.0238, 74.2179" />

      {/* 🟢 SCHEMA – LOCAL BUSINESS */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Store",
          "name": "LushDesire Rajasthan",
          "url": "https://lushdesire.in/sex-toys-delivery/rajasthan",
          "logo": "https://lushdesire.in/logo.png",
          "description": "Buy sex toys online in Rajasthan with discreet packaging. Trusted adult store delivering across Rajasthan.",
          "areaServed": {
            "@type": "State",
            "name": "Rajasthan"
          },
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "Rajasthan",
            "addressCountry": "IN"
          },
          "sameAs": [
            "https://www.facebook.com/lushdesire",
            "https://www.instagram.com/lushdesire"
          ]
        }
        `}
      </script>
    </Helmet>
  );
};

export default RajasthanSEO;
